// A signup record's query key and its compose target, shared by the tenant
// page's Signup and Email tabs and the deleted tenant's page.

import { api } from '@/api'
import type { SignupProfile } from '@/api/growthSignups'
import { invalidateQueries } from '@/lib/query'
import type { OutreachTarget } from './OutreachCompose'

/** A signup profile's target: its person, through /platform/signups/:id/outreach/*. */
export function signupTarget(signup: SignupProfile): OutreachTarget {
  return {
    to: signup.person.email,
    suppressed: signup.suppressed,
    noAddress: 'This signup has no email address.',
    previewKey: ['signups', 'outreach-preview', signup.id],
    preview: (draft, signal) => api.growth.outreach.preview(signup.id, draft, signal),
    send: (draft) => api.growth.outreach.send(signup.id, draft),
    onSent: () => invalidateQueries('signups'),
  }
}

/** A signup profile's query key. */
export const signupKey = (id: number) => ['signups', 'profile', id]
